module.exports = __webpack_public_path__ + "img/hd1.5996e141.png";